import { useState } from "react"
import styles from "./TrendsBlogToc.module.css"
import { ITrendsToc } from "@/interfaces"
import { NavLink } from "@/components/ui"
import { useGlobalContext } from "@/lib/context"
type props = {
    toc: ITrendsToc[]
}

export function TrendsBlogToc({ toc }: props) {
    const [blogToc, setBlogToc] = useState(false)
    const { props: { isMobileView } } = useGlobalContext();

    const scrollToId = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = isMobileView ? -30 : -55;
            const offsetTop = element.offsetTop - offset;
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
            if (history && history.pushState) {
                history.pushState(null, '', `#${id}`);
            } else {
                location.hash = `#${id}`;
            }
        }
    }
    return (
        <div className={styles.blogTocSec}>
            <div className={styles.tocHeadingBox}>
                <div className={styles.hamburger}>
                    <span></span>
                </div>
                <h2 className={`${styles.tbCotentHead} font16 text000 f600`}>Table of Content</h2>
            </div>
            <div className={blogToc ? `${styles.tocContentBox} ${styles.active}` : styles.tocContentBox}>
                <ul className={styles.contentMainList} >
                    {toc && toc.map((f, idx) =>
                        <li key={idx}>
                            <NavLink href={`#${f.h2.id}`} onClick={(e: any) => { e.preventDefault(); scrollToId(f.h2.id) }}>
                                <p className={styles.boldHead}>{f.h2.text}</p>
                            </NavLink>
                            <ul className={styles.contentSubList}>
                                {f.h3 && f.h3.length > 0 && f.h3.map((m, idx2) =>
                                    <NavLink href={`#${m.id}`} onClick={(e: any) => { e.preventDefault(); scrollToId(m.id) }} key={idx2}>
                                        <li>{`${`${idx + 1}.${idx2 + 1}`} ${m.text}`}</li>
                                    </NavLink>
                                )}
                            </ul>
                        </li>
                    )}
                </ul>
            </div>
            <span className={styles.readMore} onClick={() => setBlogToc(!blogToc)}>{blogToc? "Read less": "Read more"}</span>
        </div>
    )
}
